export default (params) => ({
  trigger: {
    name: 'horizontal_navigation.select_navigation',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      url: {
        type: 'string',
      },
      redirect: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'primary_navigation',
          'secondary_navigation',
          'tertiary_navigation',
        ],
      },
    },
    event: {
      name: 'select_navigation',
    },
  },
});
